import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button';
class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true, error: error };
	}

	componentDidCatch(error, errorInfo) {
		console.error(error, errorInfo);
		// logErrorToMyService(error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div dir='rtl' className='d-flex align-items-center justify-content-center flex-column flex-grow-1 min-vh-100'>
					<p>عذراً, حدث خطأ | Sorry, an error occurred</p>
					<Button className='btn-primary' type={'button'} onClick={() => window.location.reload()}>
						إعادة التحميل | Reload
					</Button>
				</div>
			);
		}

		return this.props.children;
	}
}
ErrorBoundary.propTypes = {
	children: PropTypes.node.isRequired
};

export default ErrorBoundary;
